import styled from 'styled-components';

export const TableMenuContainer = styled.div`
  padding: 0.5rem 1.375rem;

  .hefesto-table-menu__left {
    text-align: left;
    align-self: center;
    display: flex;
  }
`;
